import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { nextTick, onMounted} from 'vue'
  import headerComponent from '@/components/pub/headerComponent.vue';
  import footerComponent from '@/components/pub/footerComponent.vue';
  import sideBar from '@/components/pub/sideBar.vue';
  import UserLogin from '@/components/user/userLogin.vue'
  import BuyVip from "@/components/vip/VipDialog.vue";

 
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
  window.addEventListener("beforeunload", (e) => {
        window.scroll(0, 0);
  });
  
 })


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(headerComponent),
    _createVNode(_component_router_view),
    _createVNode(footerComponent),
    _createVNode(sideBar),
    _createVNode(UserLogin),
    _createVNode(BuyVip)
  ], 64))
}
}

})